import { defineMessages } from "@/i18n";
import en from "./en";

export const musicFrameMessages = defineMessages("frames-music", en);
